const getEmailAddressTitleForRecipient = (recipient) => {
  if (recipient.type === 'ROLE') {
    if (recipient.level === 'DEPARTMENT') {
      return `${recipient.role.name}@${recipient.department.abbreviation}`;
    }
    if (recipient.level === 'FACULTY') {
      return `${recipient.role.name}@${recipient.faculty.abbreviation}`;
    }
    return `${recipient.role.name}`;
  }

  if (recipient.type === 'PL') {
    return 'Project Leader';
  }
  if (recipient.type === 'APPROVER') {
    if (recipient.department) {
      return `Approver: ${recipient.role.name}@${recipient.department.abbreviation}`;
    }
    if (recipient.faculty) {
      return `Approver: ${recipient.role.name}@${recipient.faculty.abbreviation}`;
    }
    return `Approver: ${recipient.role?.name ?? 'By Assign'}`;
  }
};

export default getEmailAddressTitleForRecipient;
